var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.94043 1.57233C0.94043 0.771906 1.5893 0.123032 2.38973 0.123032H2.41595C3.21638 0.123032 3.86525 0.771906 3.86525 1.57233C3.86525 2.37276 3.21638 3.02163 2.41595 3.02163H2.38973C1.5893 3.02163 0.94043 2.37276 0.94043 1.57233Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.94043 7.18116C0.94043 6.38073 1.5893 5.73186 2.38973 5.73186H2.41595C3.21638 5.73186 3.86525 6.38073 3.86525 7.18116C3.86525 7.98159 3.21638 8.63046 2.41595 8.63046H2.38973C1.5893 8.63046 0.94043 7.98159 0.94043 7.18116Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.94043 12.4277C0.94043 11.6272 1.5893 10.9784 2.38973 10.9784H2.41595C3.21638 10.9784 3.86525 11.6272 3.86525 12.4277C3.86525 13.2281 3.21638 13.877 2.41595 13.877H2.38973C1.5893 13.877 0.94043 13.2281 0.94043 12.4277Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.67896 6.95302C5.67896 6.3527 6.03803 5.86604 6.48098 5.86604H20.2578C20.7007 5.86604 21.0598 6.3527 21.0598 6.95302C21.0598 7.55334 20.7007 8.04 20.2578 8.04H6.48098C6.03803 8.04 5.67896 7.55334 5.67896 6.95302Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.67896 1.47838C5.67896 0.878059 6.03803 0.391403 6.48098 0.391403H20.2578C20.7007 0.391403 21.0598 0.878059 21.0598 1.47838C21.0598 2.0787 20.7007 2.56536 20.2578 2.56536H6.48098C6.03803 2.56536 5.67896 2.0787 5.67896 1.47838Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.67896 12.4277C5.67896 11.8273 6.03803 11.3407 6.48098 11.3407H20.2578C20.7007 11.3407 21.0598 11.8273 21.0598 12.4277C21.0598 13.028 20.7007 13.5146 20.2578 13.5146H6.48098C6.03803 13.5146 5.67896 13.028 5.67896 12.4277Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListViewIcon);
export default __webpack_public_path__ + "static/media/list-view-icon.464ed02265ed6b10eaeb40b74eac380c.svg";
export { ForwardRef as ReactComponent };